import { Routes } from '@angular/router';
export const CommonLayout_ROUTES: Routes = [
  //Home
  {
    path: 'home',
    data: {
      title: 'Home'
    },
    loadChildren: () => import('../../home/home.module').then(m => m.HomeModule),
  },
  {
    path: 'stores',
    data: {
      title: 'Stores'
    },
    children: [
      {
        path: '',
        loadChildren: () => import('../../stores/stores.module').then(m => m.StoresModule)
      },
    ]
  },
  {
    path: 'stocks',
    data: {
      title: 'Stocks'
    },
    loadChildren: () => import('../../stocks/stocks.module').then(m => m.StocksModule),
  },
  {
    path: 'orders',
    data: {
      title: 'Orders'
    },
    loadChildren: () => import('../../orders/orders.module').then(m => m.OrdersModule),
  },
  {
    path: 'users',
    data: {
      title: 'Users'
    },
    loadChildren: () => import('../../users/users.module').then(m => m.UsersModule),
  },
  {
    path: 'messages',
    data: {
      title: 'Messages'
    },
    loadChildren: () => import('../../messages/messages.module').then(m => m.MessagesModule),
  },
  {
    path: 'details',
    data: {
      title: 'Details'
    },
    loadChildren: () => import('../../details/details.module').then(m => m.DetailsModule),
  },
  {
    path: 'alerts',
    data: {
      title: 'Alerts'
    },
    loadChildren: () => import('../../alerts/alerts.module').then(m => m.AlertsModule),
  },
  {
    path: 'settings',
    data: {
      title: 'Settings'
    },
    loadChildren: () => import('../../settings/settings.module').then(m => m.SettingsModule),
  },
  {
    path: 'analytics',
    data: {
      title: 'Analytics'
    },
    loadChildren: () => import('../../analytics/analytics.module').then(m => m.AnalyticsModule),
  },
  {
    path: 'sales',
    data: {
      title: 'Sales'
    },
    loadChildren: () => import('../../sales/sales.module').then(m => m.SalesModule),
  },
  {
    path: 'accounts',
    data: {
      title: 'Accounts'
    },
    loadChildren: () => import('../../accounts/accounts.module').then(m => m.AccountsModule),
  },
  {
    path: 'marketing',
    data: {
      title: 'Marketing'
    },
    loadChildren: () => import('../../marketing/marketing.module').then(m => m.MarketingModule),
  },
  {
    path: 'links',
    data: {
      title: 'Links'
    },
    loadChildren: () => import('../../links/links.module').then(m => m.LinksModule),
  },
  {
    path: 'documents',
    data: {
      title: 'Documents'
    },
    children: [
      {
        path: '',
        loadChildren: () => import('../../documents/documents.module').then(m => m.DocumentsModule)
      },
    ]
  },
  {
    path: 'activities',
    data: {
      title: 'Activities'
    },
    children: [
      {
        path: '',
        loadChildren: () => import('../../activities/activities.module').then(m => m.ActivitiesModule)
      },
    ]
  }
];
